import { css } from "@obby/components";

export const styles = {
  teacherJoinPage: css({
    backgroundColor: "#fafafa",
    paddingTop: "$mdTop",

    "@lg": {
      paddingTop: "@lg-top"
    }
  }),
  section: css({
    overflow: "hidden",

    variants: {
      backgroundcolor: {
        white: {
          backgroundColor: "white"
        }
      }
    }
  }),
  sectionTitle: css({
    fontFamily: "$foundersGroteskCondensed",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "28px",
    lineHeight: "100%",
    textAlign: "center",
    letterSpacing: "0.01em",
    textTransform: "uppercase",
    color: "$ebonyClay",
    margin: "0",
    "@smd": {
      fontSize: "32px"
    },
    "@lg": {
      fontSize: "52px"
    }
  }),
  sectionDescription: css({
    fontFamily: "$foundersGrotesk",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "20px",
    lineHeight: "140%",
    textAlign: "center",
    letterSpacing: "0.01em",
    color: "$ebonyClay",
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto"
  }),
  header: css({
    position: "relative"
  }),
  headerBalloon: css({
    display: "none",
    position: "absolute",
    bottom: "-128px",
    right: "-110px",
    height: "300px",

    path: {
      fill: "$hummingBird"
    },

    "@smd": {
      display: "block"
    },
    "@lg": {
      height: "500px",
      bottom: "-200px",
      right: "-200px"
    }
  }),
  balloonCard: css({
    margin: "auto"
  }),
  howItWorksBalloon: css({
    width: "20%",
    position: "absolute",

    path: {
      fill: "$hummingBird"
    },

    variants: {
      variant: {
        first: {
          left: "50%",
          top: "52%"
        },
        second: {
          left: "30%",
          top: "15%",
          transform: "matrix(0.49, 0.86, -0.88, 0.49, 0, 0)"
        },
        third: {
          right: "0",
          top: "-5%"
        }
      }
    }
  }),
  obbyGift: css({
    position: "absolute",
    width: "22%",
    top: "70%",
    transform: "rotate(-3deg)"
  })
};
